export const addElipsis = (pages) => {
  if (pages.length > 1 && pages[1] !== pages[0] + 1) {
    insertElipsis(pages, 1);
  }

  const l = pages.length;
  if (pages.length > 2 && pages[l - 1] !== pages[l - 2] + 1) {
    insertElipsis(pages, l - 1);
  }
  return pages;
};

export const insertElipsis = (pages, index) => pages.splice(index, 0, "..");
